import {
  ITenantUser,
  IcreateUpdateTenantUserProps,
  IInitialTenantUsersState,
} from 'interfaces/tenantUsers.interface';
import * as TenantUsersTypes from './tenantUsers.types';
import { InotificationsTypesItem } from 'interfaces/notifications.interface';

export type TtenantUsersDispatchReducer =
  | {
      type: typeof TenantUsersTypes.GET_BRAND_USERS;
      payload: Array<ITenantUser>;
    }
  | {
      type: typeof TenantUsersTypes.CREATE_BRAND_USER;
      payload: ITenantUser;
    }
  | {
      type: typeof TenantUsersTypes.UPDATE_BRAND_USER;
      payload: {
        key: string;
        user: IcreateUpdateTenantUserProps;
        notifications: Array<InotificationsTypesItem>;
      };
    }
  | {
      type: typeof TenantUsersTypes.SELECT_BRAND_USER;
      payload: ITenantUser | null;
    }
  | {
      type: typeof TenantUsersTypes.DELETE_BRAND_USER;
      payload: string;
    }
  | {
      type: typeof TenantUsersTypes.SET_IS_LOADING_ACTION;
      payload: boolean;
    };

export default function tenantUsersReducer(
  state: IInitialTenantUsersState,
  action: TtenantUsersDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case TenantUsersTypes.GET_BRAND_USERS: {
      const getTenantUsers: IInitialTenantUsersState = {
        ...state,
        tenantUsers: payload,
      };
      return getTenantUsers;
    }

    case TenantUsersTypes.SELECT_BRAND_USER: {
      const selectTenantUser: IInitialTenantUsersState = {
        ...state,
        tenantUsersSelected: payload,
      };
      return selectTenantUser;
    }

    case TenantUsersTypes.CREATE_BRAND_USER: {
      const createTenantUser: IInitialTenantUsersState = {
        ...state,
        tenantUsers: [...state.tenantUsers, payload],
      };
      return createTenantUser;
    }

    case TenantUsersTypes.UPDATE_BRAND_USER: {
      const updateTenantUser: IInitialTenantUsersState = {
        ...state,
        tenantUsers: state.tenantUsers.map((user) => {
          const updatedUser: ITenantUser = {
            ...user,
            ...payload.user,
            user_notifications: payload.notifications,
          };

          return user.key === payload.key ? updatedUser : user;
        }),
      };
      return updateTenantUser;
    }

    case TenantUsersTypes.DELETE_BRAND_USER: {
      const deleteTenantUser: IInitialTenantUsersState = {
        ...state,
        tenantUsers: state.tenantUsers.filter((user) => user.key !== payload),
      };
      return deleteTenantUser;
    }

    case TenantUsersTypes.SET_IS_LOADING_ACTION: {
      const setIsLoadingAction: IInitialTenantUsersState = {
        ...state,
        isLoadingAction: payload,
      };
      return setIsLoadingAction;
    }

    default:
      return state;
  }
}
